import { useEffect, useState } from "react";
import { useOnline } from "@/hooks/useOnline";
import { RunSheet } from "./RunSheet";
import type { RunDayTransport } from "@/pages/RunDay";
export function CompleteCompetitionSheet({
  competitionId,
  transport,
  close,
  saved,
}: {
  competitionId: string;
  transport: RunDayTransport;
  close: () => void;
  saved: () => Promise<void>;
}) {
  const online = useOnline();
  const [preview, setPreview] = useState<{
    version: number;
    incomplete_heats: { id: string; name: string; status: string }[];
  } | null>(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let active = true;
    void transport
      .get<typeof preview>(`/api/competitions/${competitionId}/lifecycle`)
      .then((value) => {
        if (active) setPreview(value);
      })
      .catch((e) => setError(e.message));
    return () => {
      active = false;
    };
  }, [competitionId, transport]);
  return (
    <RunSheet title="Complete competition?" close={close}>
      <p>This locks scoring for the competition.</p>
      {error && <p role="alert">{error}</p>}
      {preview && (
        <>
          <p>{preview.incomplete_heats.length} incomplete heats remain.</p>
          {preview.incomplete_heats.length > 0 && (
            <ul>
              {preview.incomplete_heats.map((h) => (
                <li key={h.id}>
                  {h.name} · {h.status}
                </li>
              ))}
            </ul>
          )}
        </>
      )}
      <button
        className="run-primary"
        disabled={!online || busy || !preview || preview.incomplete_heats.length > 0}
        onClick={async () => {
          if (!preview || !online) return;
          setBusy(true);
          try {
            await transport.post(`/api/competitions/${competitionId}/complete`, {
              expected_version: preview.version,
            });
            await saved();
            close();
          } catch (e) {
            setError(e instanceof Error ? e.message : "Could not complete the competition");
          } finally {
            setBusy(false);
          }
        }}
      >
        Complete competition
      </button>
      <button onClick={close}>Keep competition open</button>
    </RunSheet>
  );
}
